import { Component, Input } from '@angular/core';
import { FilterModelDto } from '../../../../models/filter.model';

@Component({
  selector: 'app-payment-links-list-filter',
  templateUrl: './payment-links-list-filter.component.html',
  styleUrls: ['./payment-links-list-filter.component.scss'],
})
export class PaymentLinksListFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined;
  @Input() filterPaylinkTypes: FilterModelDto[] | undefined;
  @Input() filterSinglePayments: FilterModelDto[] | undefined;
  @Input() filterCurrencies: FilterModelDto[] | undefined;

  filterStart: FilterModelDto = {
    fieldName: 'date_start_from',
    value: '',
    description: '',
  };

  filterEnd: FilterModelDto = {
    fieldName: 'date_start_to',
    value: '',
    description: '',
  };

  filterSumFrom: FilterModelDto = {
    fieldName: 'paylink_amount_from',
    value: '',
    description: '',
  };

  filterSumTo: FilterModelDto = {
    fieldName: 'paylink_amount_to',
    value: '',
    description: '',
  };
}
